module.exports = "<Spinner animation=\"border\" />;\n"